import { FastFilters } from '../fast_filters';
import { appendPreloader } from '../preloader';

export function init(fastFilters: FastFilters) {
  const button = document.querySelector('[data-mark=map]') as HTMLButtonElement;

  if (!button) {
    return () => [];
  }

  let removePreloader: (() => void) | undefined;

  const buttonClickListener = () => {
    fastFilters.scheduleClick('map', () => {
      if (removePreloader) {
        removePreloader();
        removePreloader = undefined;
      }
    });

    removePreloader = appendPreloader(button, {
      size: 13,
      style: 'position:relative;top:2px;margin-left:8px;',
    });
  };

  button.addEventListener('click', buttonClickListener);

  return () => {
    button.removeEventListener('click', buttonClickListener);
  };
}
